/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import React, { useEffect, useState } from "react";

// Material Dashboard 2 React example components
import DashboardLayout from "pages/LayoutContainers/DashboardLayout";
import DashboardNavbar from "pages/Navbars/DashboardNavbar";
import AuthGuard from "components/AuthGuard";
import INDataTable from "components/INDataTable";
import MDTypography from "components/MDTypography";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources, siteData } from "../../authConfig";

function KibanaEmbed() {
  return (
    <div className="App">
      <iframe
        src="https://thsenseriskelastic.kb.eastus.azure.elastic-cloud.com/app/dashboards#/view/d850dff2-3ac2-4ea0-8883-0442438c490b?embed=true&_g=%28refreshInterval%3A%28pause%3A%21t%2Cvalue%3A60000%29%2Ctime%3A%28from%3Anow-15m%2Cto%3Anow%29%29"
        height="800"
        width="100%"
        frameBorder="0"
      />
    </div>
  );
}

function AuditListContent() {
  console.log("siteData?.apiScopes", siteData?.apiScopes);
  const { error, execute } = useFetchWithMsal({
    scopes: [siteData?.apiScopes],
  });

  const [auditData, setAuditData] = useState(null);
  const columns = [
    {
      accessorKey: "name", // access nested data with dot notation
      header: "Audit",
      size: 150,
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 150,
    },
    {
      accessorKey: "rating", // normal accessorKey
      header: "Rating",
      size: 200,
    },
    {
      accessorKey: "Sub Category",
      header: "Sub Category",
      size: 150,
    },
    {
      accessorKey: "File",
      header: "File",
      size: 150,
    },
  ];
  useEffect(() => {
    if (!auditData) {
      execute("GET", `${protectedResources.apiTodoList.endpoint}/auditdata`).then((response) => {
        setAuditData(response);
      });
    }
  }, [execute, auditData]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      {auditData ? (
        <>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Audit Records
            </MDTypography>
          </MDBox>
          <INDataTable
            disableCard
            columns={columns}
            data={auditData}
            initialState={{
              density: "compact",
            }}
          />
        </>
      ) : null}
    </>
  );
}

function Dashboard() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <AuthGuard>
          <KibanaEmbed />
        </AuthGuard>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
